import React, { useState, useEffect } from 'react';
import './CookiesPopup.css';

const CookiesPopup = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');

        // Fuerza a mostrar el popup para pruebas, elimina esto en producción
        const forceShow = false; // ← pon esto en false para comportamiento normal

        if (!consent || forceShow) setShowPopup(true);
    }, []);

    const handleConsent = (value) => {
        localStorage.setItem('cookieConsent', value);
        setShowPopup(false);
        // Aquí podrías activar/desactivar scripts como Google Analytics si hace falta
    };

    if (!showPopup) return null;

    return (
        <div className="cookies-popup">
            <div className="cookies-popup-content">
                <div className="cookies-icon">
                    🍪
                </div>
                <div className="cookies-text">
                    <p>
                        Utilizamos cookies propias y de terceros para analizar la navegación de los usuarios y mejorar nuestros servicios.
                        Puedes <a href="/cookies">leer más aquí</a>.
                    </p>
                </div>
            </div>

            <div className="cookies-popup-buttons">
                {/* Usamos el botón con borde blanco del nuevo diseño */}
                <button onClick={() => handleConsent('rejected')} className="btn btn-gw cookies-btn">
                    Rechazar
                </button>
                {/* Usamos el botón azul sólido del nuevo diseño */}
                <button onClick={() => handleConsent('accepted')} className="btn btn-blue cookies-btn">
                    Aceptar
                </button>
            </div>
        </div>
    );
};

export default CookiesPopup;